import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./ops.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { OpsLayout } from "./layout/OpsLayout.js";
import { createQueryClient } from "./lib/queryClient.js";
import { AnalyticsPage } from "./routes/AnalyticsPage.js";
import { AuditPage } from "./routes/AuditPage.js";
import { CustomerDetailPage } from "./routes/CustomerDetailPage.js";
import { CustomersListPage } from "./routes/CustomersListPage.js";
import { CustomersNewPage } from "./routes/CustomersNewPage.js";
import { SettingsPage } from "./routes/SettingsPage.js";
import { SignInPage } from "./routes/SignInPage.js";
import { TeamPage } from "./routes/TeamPage.js";
import { WebhooksPage } from "./routes/WebhooksPage.js";
import { veritrellisTheme } from "./theme/veritrellisTheme.js";

const queryClient = createQueryClient();

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={veritrellisTheme} defaultColorScheme="light">
        <Notifications position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/sign-in" element={<SignInPage />} />
            <Route element={<OpsLayout />}>
              <Route path="/" element={<Navigate to="/customers" replace />} />
              <Route path="/customers" element={<CustomersListPage />} />
              <Route path="/customers/new" element={<CustomersNewPage />} />
              <Route path="/customers/:workspaceId" element={<CustomerDetailPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/audit" element={<AuditPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/webhooks" element={<WebhooksPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/customers" replace />} />
          </Routes>
        </BrowserRouter>
      </MantineProvider>
    </QueryClientProvider>
  );
};
